import React, {useContext, useEffect} from 'react';
import PropTypes from 'prop-types';

import SelectedItemPackingDrawer from "../SelectedItemPackingDrawer";
import WmsItemInformationPacking from "../WmsItemInformationPacking";

import {BarCodeScannerContext} from "../../../../../../../../contexts/barCodeScannerContext";

import {packingStepNames} from "../../../packingSteps";
import {PackingContext} from "../../../PackingContext";
import {Grid} from "@mui/material";
import MultiExpeditonSessionMoreDrawer from "../MultiExpeditonSessionMoreDrawer";

ShipmentMonoPacking.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    beginPacking:PropTypes.func.isRequired,
    beginShipmentWeigh: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
};

function ShipmentMonoPacking({open, handleClose, beginPacking, beginShipmentWeigh, packingStep}) {
    const {scannedString, resetScannedString} = useContext(BarCodeScannerContext)
    const {isMultiSessionPacking, shipmentSplitNewShipment} = useContext(PackingContext)

    // A "mono" shipment (single active line item) can still hold a second WMSItem that is
    // flagged toBeCancelled but not yet put away (see WmsItemCanceller::flagToCancel). Prefer the
    // real item first (so the PEEK scan matches the article actually being shipped), then the
    // to-be-cancelled item once the real one is packed, instead of freezing on lineItems[0].
    const lineItems = packingStep.selectedShipment.lineItems
    const lineItem = lineItems.find((item) => !item.isPacked && !item.isCancelled && !item.wmsItem.toBeCancelled)
        ?? lineItems.find((item) => !item.isPacked && !item.isCancelled)
        ?? lineItems.find((item) => item.isPacked)
        ?? lineItems[0]

    useEffect(() => {
        if (packingStep.stepName === packingStepNames.PEEK && scannedString === lineItem.eanCode) {
            resetScannedString()
            beginPacking()
        }
    }, [scannedString]);

    useEffect(() => {
        if (isMultiSessionPacking && packingStepNames.PEEK === packingStep.stepName) {
            beginPacking()
        }
    }, [packingStep.selectedShipment.shipmentId]);

    return (
        <SelectedItemPackingDrawer
            open={open}
            handleClose={handleClose}
            packingStep={packingStep}
            footer={
                <Grid container>
                    {packingStepNames.PACK_ITEMS === packingStep.stepName && isMultiSessionPacking && (
                        <MultiExpeditonSessionMoreDrawer fullWidth/>
                    )}
                </Grid>
            }
        >
            <WmsItemInformationPacking
                lineItem={lineItem}
                packingStep={packingStep}
                beginPacking={beginPacking}
                beginShipmentWeigh={beginShipmentWeigh}
            />
        </SelectedItemPackingDrawer>
    );
}

export default ShipmentMonoPacking;
